import type { CbiFrontendServiceContext } from "../../frontend/context/CbiFrontendServiceContext";
import type { ApClassDTOBase } from "./ApClassDTOBase";
import type { ClassAvailability } from "./ClassAvailability";
import type { TrackedBase } from "./TrackedBase";

export class ApClassMember implements ApClassDTOBase, TrackedBase {
  constructor(public readonly instanceId: number, public readonly cancelByOverride: Date | null, public readonly signupsStartOverride: Date | null, public readonly cancelledDatetime: Date | null, public readonly price: number | null, public readonly signupMax: number | null, public readonly signupMin: number | null, public readonly doNotAutoCancel: string | null, public readonly hideOnline: string | null, public readonly availability: ClassAvailability | null, public readonly createdOn: Date | null, public readonly createdBy: string | null, public readonly updatedOn: Date | null, public readonly updatedBy: string | null) {
    this.cbiServiceContext = null;
  }
  cbiServiceContext: CbiFrontendServiceContext | null;
  async summaryLabel(): Promise<string> {
    return await this.cbiServiceContext!.apClassService().summaryLabelMember({ instanceId: this.instanceId });
  }
}
